// extracted by mini-css-extract-plugin
export var childrenContainer = "_ch-0";
export var virtualScrollArea = "_ch-1";